export const BUSINESS_TAB_KEY = 'business';

export const FORMIK_BUSINESS_FIELD_IDS = {
  AU_NZ_BUSINESS_NUMBER: 'au_nz_business_number',
  BUSINESS_LEGAL_NAME: 'business_legal_name',
  BUSINESS_TRADING_NAME: 'business_trading_name',
  AU_NZ_COMPANY_NUMBER: 'au_nz_company_number',
  BUSINESS_VALIDATION: 'business_validation',
} as const;

export const BUSINESS_FIELDS_TO_WATCH = [
  FORMIK_BUSINESS_FIELD_IDS.AU_NZ_BUSINESS_NUMBER,
  FORMIK_BUSINESS_FIELD_IDS.BUSINESS_LEGAL_NAME,
  FORMIK_BUSINESS_FIELD_IDS.BUSINESS_TRADING_NAME,
  FORMIK_BUSINESS_FIELD_IDS.AU_NZ_COMPANY_NUMBER,
] as const;
